module.exports = __webpack_public_path__ + "static/media/Persoonsgerichte-zorg_v3.1d9b91e5.jpg";